<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="-1" tab-position="left" style="background-color: #FFFFFF;height: 85vh">
        <el-tab-pane name="-1" label="下载奖励开关">
          <el-card>
            <div slot="header" class="clearfix"><span>下载奖励开关</span></div>
            <el-form class="demo-form-inline">
              <el-form-item label="最大等级">
                <el-switch v-model="formData.switch" active-text="开启" inactive-text="关闭" :active-value="1" :inactive-value="0" />
              </el-form-item>
              <el-form-item label="奖励">
                <Reward :value="formData.reward" />
              </el-form-item>
              <el-button v-permisaction="['config:advertConfig:add']" size="small" type="primary" @click="onSubmit()">保存</el-button>
            </el-form>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="0" label="广告分组配置">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel ref="CommonExcelRef" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importGroupCfg" :export-method="exportGroupCfg" />
                <clear-cache-apply />
                <sync-data />
              </el-row>
            </div>
            <el-table size="mini" :data="groupConfig" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template v-slot:default="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="奖励配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.rewardId">
                    <el-option v-for="item in list[1]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <el-button size="mini" type="danger" @click="deleteGroupConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="addGroupConfig()">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveGroup()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%">
              <el-table-column label="序号" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template v-slot:default="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="提示" :visible.sync="dialog" width="60%">
        <el-table :data="diaLogList" border stripe>
          <el-table-column prop="name" label="类型" width="200px">
            <template v-slot:default="scope">
              <el-select v-model.number="scope.row.type" placeholder="请选择">
                <el-option v-for="item in adType" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="等级范围" width="200px">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.level_start" style="width: 43%" placeholder="最小等级" />
              -
              <el-input v-model.number="scope.row.level_end" style="width: 43%" placeholder="最大等级" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="体力范围" width="200px">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.spin_start" style="width: 43%" placeholder="最小等级" />
              -
              <el-input v-model.number="scope.row.spin_end" style="width: 43%" placeholder="最大等级" />
            </template>
          </el-table-column>
          <el-table-column prop="v" label="权重" width="200px">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.v" placeholder="权重" />
            </template>
          </el-table-column>
          <el-table-column prop="pro" label="概率(%)" width="200px">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.pro" placeholder="概率" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称" width="200px">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.name" placeholder="名称" />
            </template>
          </el-table-column>
          <el-table-column prop="trueId" label="trueId" width="200px">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.trueId" placeholder="trueId" />
            </template>
          </el-table-column>
          <el-table-column prop="trueId_ios" label="trueId_ios" width="200px">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.trueId_ios" placeholder="trueId_ios" />
            </template>
          </el-table-column>
          <el-table-column prop="sceneId" label="sceneId" width="200px">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.sceneId" placeholder="sceneId" />
            </template>
          </el-table-column>
          <el-table-column prop="sceneId_ios" label="sceneId_ios" width="200px">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.sceneId_ios" placeholder="sceneId_ios" />
            </template>
          </el-table-column>
          <el-table-column prop="max" label="最大次数" width="200px">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.max" placeholder="最大次数" />
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="200px">
            <template v-slot:default="scope">
              <el-select v-model.number="scope.row.status" placeholder="请选择">
                <el-option v-for="item in statusMap" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="cd" label="冷却时间(s)" width="200px">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.cd" placeholder="冷却时间(s)" />
            </template>
          </el-table-column>
          <el-table-column label="奖励" width="200px">
            <template v-slot:default="scope">
              <Reward :value="scope.row.reward[0].reward" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px;">
            <template v-slot:default="scope">
              <el-button type="primary" size="mini" @click="handlerDrawerVisible(scope.$index,scope.row.reward)">配置</el-button>
              <el-button type="danger" size="mini" style="margin-left: 15px;" @click="delEvent(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-permisaction="['config:advertConfig:add']" style="margin-top: 10px" type="primary" @click="addEvent()">+</el-button>
        <el-button v-permisaction="['config:advertConfig:add']" style="margin-top: 10px" type="primary" @click="dialog = false">保存</el-button>
      </el-dialog>
      <el-drawer title="配置" :visible.sync="drawerVisible" direction="rtl" size="600px">
        <el-form>
          <el-row v-for="(p,i) in drawerConfig" :key="i">
            <el-form-item label="倍数" style="margin-top: 10px;">
              <el-input v-model.trim="p.bet" style="width: 300px;" placeholder="倍数" />
            </el-form-item>
            <el-form-item label="次数" style="margin-top: 10px;">
              <el-input v-model.number="p.time" style="width: 300px;" placeholder="次数" />
            </el-form-item>
            <el-form-item label="提示" style="margin-top: 10px;">
              <el-input v-model="p.tips" style="width: 300px;" placeholder="提示" />
            </el-form-item>
            <el-form :inline="true">
              <el-form-item style="margin-top: 10px;">
                {{ showGetConfig(p._config) }}
              </el-form-item>
              <el-form-item style="margin-top: 10px;">
                <el-button type="primary" style="margin-left: 16px;" @click="handlerDrawerVisible2(p._config)">权重配置</el-button>
              </el-form-item>
            </el-form>
            <el-form-item style="margin-top: 10px">
              <el-button v-permisaction="['config:advertConfig:del']" type="danger" @click="removeReward3(i)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item style="margin-top: 10px">
            <el-button v-if="drawerConfig.length <= 0" v-permisaction="['config:advertConfig:add']" type="primary" @click="addReward()">+</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
      <el-drawer title="权重配置" :visible.sync="drawerVisible2" direction="rtl" :append-to-body="true" size="750px" @close="closeDrawerConfig2(drawerConfig2)">
        <el-form :inline="true">
          <el-row v-for="(pp,pi) in drawerConfig2" :key="pi">
            <el-form-item label="道具" style="margin-top: 5px;">
              <el-select v-model.number="pp.type" filterable style="width: 130px;" placeholder="请选择">
                <el-option v-for="(item, index) in typesMap" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="数量" style="margin-top: 5px;">
              <el-input v-model.number="pp.num" style="width: 130px;" placeholder="数量" />
            </el-form-item>
            <el-form-item label="权重" style="margin-top: 5px;">
              <el-input v-model.number="pp.v" style="width: 130px;" placeholder="权重" />
            </el-form-item>
            <el-form-item style="margin-top: 5px;">
              <el-button v-permisaction="['config:advertConfig:add']" type="danger" @click="removeReward2(pi)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item style="margin-top: 10px">
            <el-button v-permisaction="['config:advertConfig:add']" type="primary" @click="addReward2()">+</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </template>
  </BasicLayout>
</template>

<script>
import { getAdSwitchCfg, updateAdSwitchCfg } from '@/api/config/ad-cfg'
import Reward from '@/components/Reward/index.vue'
import CommonExcel from '@/components/CommonExcel'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import {
  actionComAuxiliary,
  comAuxiliary,
  delComAuxiliary
} from '@/api/config/activity-auxiliary-cfg'
import { Message } from 'element-ui'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'Ad',
  components: { SyncData, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      adType: [
        { label: '棋盘电视机', value: 1 },
        { label: '体力不足触发点', value: 2 },
        { label: '商城', value: 3 },
        { label: '金币不足', value: 4 },
        { label: '投筛子', value: 5 },
        { label: '商城木宝箱', value: 6 },
        { label: '搭桥快跑复活', value: 7 },
        { label: '捡钱快跑复活', value: 8 },
        { label: '跳一跳复活', value: 9 },
        { label: '插屏广告', value: 12 },
        { label: '过关双倍', value: 13 },
        { label: '偷双倍', value: 14 },
        { label: '打双倍', value: 15 },
        { label: '建筑大师双倍', value: 16 },
        { label: '跳过双倍弹插屏广告', value: 17 },
        { label: '增加每日任务奖励', value: 19 },
        { label: '应用内购买每日奖励免广告礼包', value: 20 }
      ],
      statusMap: [
        { label: '关闭', value: 0 },
        { label: '开启苹果', value: 1 },
        { label: '开启安卓', value: 2 },
        { label: '开启全部', value: 3 }
      ],
      typesMap: [
        { label: '金币', value: 'coins' },
        { label: '体力', value: 'spins' },
        { label: '盾', value: 'shield' }
      ],
      formData: { switch: 0, reward: [{ propsId: 3, skin: 0, num: 1, rtype: 2 }] },
      tableData: [],
      groupConfig: [],
      groupsList: [],
      curClass: 'adGroupConfig',
      list: [],
      typeArr: { 1: '广告配置' },
      diaLogList: [],
      dialog: false,
      drawerVisible: false,
      drawerConfigIndex: -1,
      drawerConfig: [],
      drawerVisible2: false,
      drawerConfig2: []
    }
  },
  created() {
    this.initCfg()
  },
  methods: {
    initCfg() {
      getAdSwitchCfg().then(res => {
        if (res.data.reward === null) {
          res.data.reward = []
        }
        this.formData = res.data
      })
      getUserTypeAllList().then(res => {
        this.groupsList = [{ name: '默认', id: 0 }]
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
        getCommonCfg({ name: this.curClass }).then(res => {
          this.groupConfig = res.data
        })
      })
      this.getList()
    },
    getList() {
      this.loading = true
      comAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    onSubmit() {
      updateAdSwitchCfg({ data: JSON.stringify(this.formData) }).then(res => {
        this.msgSuccess(res.msg)
      })
    },
    removeReward(index) {
      this.formData.reward = this.formData.reward.filter((item, key) => {
        return index !== key
      })
    },
    removeReward3(index) {
      this.drawerConfig.splice(index)
    },
    delEvent(index) {
      this.diaLogList.splice(index)
    },
    addEvent() {
      this.diaLogList.push({ type: 1, level_start: 0, level_end: 0, spin_start: 0, spin_end: 0, v: 0, pro: 0, trueId: '', trueId_ios: '', name: '', max: 0, reward: [{ bet: 0, time: 0, tips: '', reward: [], conf: [], _config: [] }], status: 1, group_pro: [], sceneId: '', sceneId_ios: '', cd: 0 })
    },
    addReward() {
      this.drawerConfig.push({ bet: 1, time: 1, tips: '', reward: [], _config: [], conf: [] })
    },
    addReward2() {
      this.drawerConfig2.push({ type: 'coins', num: 1, v: 1 })
    },
    removeReward2(index) {
      this.drawerConfig2.splice(index)
    },
    showGetConfig(config) {
      const arr = []
      for (const i in config) {
        const val = config[i]
        for (const k in this.typesMap) {
          const c = this.typesMap[k]
          if (c.value === val.type) {
            arr.push(c.label + '*' + val.num)
            break
          }
        }
      }
      return arr.join(',')
    },
    deleteGroupConfig(index) {
      this.groupConfig.splice(index, 1)
    },
    addGroupConfig() {
      this.groupConfig.push({ minLv: 1, maxLv: 999, groupIds: [], rewardId: 0 })
    },
    importGroupCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.groupConfig = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'name', 'id')
        break
      }
    },
    exportGroupCfg() {
      const fileName = '广告分组配置'
      const hearer = []
      const excelData = []
      const name = ['广告分组配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.groupConfig, { groupIds: this.groupsList, rewardId: this.list[1] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, rewardId: '奖励配置' })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    handleSaveGroup() {
      updateCommonCfg({ name: this.curClass, data: JSON.stringify(this.groupConfig) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
    openDialog(config) {
      this.dialog = true
      this.diaLogList = config
    },
    handleDel(index, id) {
      if (id !== 0) {
        delComAuxiliary({ idList: [id] })
      }
      this.list[this.type].splice(index, 1)
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    handleSaveConfig() {
      actionComAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        Message({ message: '保存成功', type: 'success', duration: 5 * 1000 })
      })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            for (let j = 0; j < excelData[i].sheetData.length; j++) {
              excelData[i].sheetData[j].reward = this.$refs.RewardRef.handleTranToVal(excelData[i].sheetData[j].reward)
            }
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    handlerDrawerVisible(index, reward) {
      this.drawerVisible = true
      for (const i in reward) {
        const val = reward[i]
        const config = []
        for (const j in val.conf) {
          const c = val.conf[j]
          config.push({ type: j, num: c.num, v: c.v })
        }
        reward[i]['_config'] = config
      }
      this.drawerConfig = reward
      this.drawerConfigIndex = index
    },
    handlerDrawerVisible2(reward) {
      this.drawerVisible2 = true
      this.drawerConfig2 = reward
    },
    closeDrawerConfig2(drawerConfig2) {
      const mapVal = {}
      for (const j in drawerConfig2) {
        const c = drawerConfig2[j]
        mapVal[c.type] = { num: c.num, v: c.v }
      }
      for (const k in this.diaLogList) {
        if (parseInt(k) === this.drawerConfigIndex) {
          this.diaLogList[k].reward[0].conf = mapVal
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
